import RocketsNavigation from './components/RocketsNavigation'
import StarNavigation from './components/StarsNavigation'
import LevelNavigation from './components/LevelNavigation'
import css from './navigation.module.css'
import { PropsWithChildren } from 'react'

const Navigation = (props: PropsWithChildren) => {
  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <div className={css.wrapper}>
        <RocketsNavigation />
        <StarNavigation />
        <LevelNavigation />
      </div>
      <div className={css.content}>{props.children}</div>
    </div>
  )
}

export default Navigation
